/*
 * CASA SOFIA — global boot.
 *
 * Wires the two cross-page behaviours that have no custom element of their own:
 *
 *   1. Scroll reveal — boots the shared IntersectionObserver (reveal.js) that
 *      fades below-the-fold sections in.
 *
 *   2. Header scroll state — ports the useEffect in app/components/Header.tsx:
 *      past 24px of scroll the home header swaps from transparent overlay to the
 *      solid blurred bar (base.css `.site-header.is-home.is-scrolled`). The read
 *      is rAF-throttled (one layout read per frame) and the listener is passive.
 *      Inner-page headers are sticky/solid regardless, but the class is harmless
 *      there, so we toggle it on whatever `.site-header` exists.
 *
 * Loaded as a module after aside.js; runs once the DOM is parsed.
 */

import {initReveal} from './reveal.js';

const SCROLL_THRESHOLD = 24;

function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let ticking = false;
  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  update(); // set initial state (e.g. reloaded mid-page)
  window.addEventListener('scroll', onScroll, {passive: true});
}

function boot() {
  initReveal();
  initHeaderScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, {once: true});
} else {
  boot();
}
